
import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Tag } from 'lucide-react';
import { TagManagement } from './TagManagement';

interface TagManagementDialogProps {
  children?: React.ReactNode;
  onTagSelected?: (tagId: string) => void;
  selectionMode?: boolean;
  selectedTags?: string[];
}

export const TagManagementDialog = ({ 
  children, 
  onTagSelected,
  selectionMode = false,
  selectedTags = []
}: TagManagementDialogProps) => {
  const [open, setOpen] = useState(false);

  const handleTagSelected = (tagId: string) => {
    if (onTagSelected) {
      onTagSelected(tagId);
    }
    if (selectionMode) {
      // Don't auto-close in selection mode to allow multiple selections
      return;
    }
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {children || (
          <Button variant="outline" size="sm">
            <Tag className="h-4 w-4 mr-2" />
            Manage Tags
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="max-w-md max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {selectionMode ? 'Select or Create Tags' : 'Manage Tags'}
            {selectionMode && selectedTags.length > 0 && (
              <span className="text-sm font-normal text-muted-foreground ml-2">
                ({selectedTags.length} selected)
              </span>
            )}
          </DialogTitle>
        </DialogHeader>
        
        <TagManagement
          onTagSelected={handleTagSelected}
          selectionMode={selectionMode}
          selectedTags={selectedTags}
        />
        
        {selectionMode && (
          <div className="flex justify-end pt-4">
            <Button onClick={handleClose}>
              Done
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
